export default {"src":"/_next/static/media/ic-QR.a0bf0e7f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};